import React from "react";
import ModalComponent from "../../../../components/modalComponent/ModalComponent";
import { getNbMealPackages, checkIfWarningInvitation } from "../presence.utils";

const ValidateMealPackagesModal = ({ isModalOpen, onCloseModal, onValidate, weekData }) => {
  const days = weekData.data || [];
  const nbDays = days.length;
  const nbGrantedMealPackages = getNbMealPackages(weekData);
  const warningInvitations = checkIfWarningInvitation(weekData);
  const pluralize = nbGrantedMealPackages > 1 ? "s" : "";

  return (
    <ModalComponent
      title="Etes-vous sur de vouloir valider les forfaits repas de la semaine ?"
      showModal={isModalOpen}
      closeModal={onCloseModal}
    >
      <div>
        <div>
          <div className="m-6">
            {warningInvitations.length > 0 &&
              warningInvitations.map(item => (
                <strong style={{ color: "red" }}>
                  Attention, le forfait repas du {item} a été accordé alors qu'il existe une note de frais de type
                  "invitations" ce jour là.
                </strong>
              ))}
          </div>
          <div className="m-6">
            <strong>{`Il y a ${nbGrantedMealPackages} forfait${pluralize} repas accordé${pluralize} sur ${nbDays} possible${
              nbDays > 1 ? "s" : ""
            } cette semaine.`}</strong>
          </div>
          <div>
            <p>
              La validation des forfaits repas <strong>figera</strong> l'ensemble des forfaits repas de la semaine et
              ils ne pourront donc plus être requalifiés sans passer par ticket pour l'IT. Il est donc nécessaire de
              vérifier que les forfaits repas de toute la semaine ont été qualifiés comme voulu.
            </p>
            <p>
              <strong>ps</strong> : il est cependant possible de modifier <strong>le jour même</strong>, les forfaits
              repas déjà validés qui n'ont pas été accordés sans passé par un ticket pour l'IT.
            </p>
          </div>
        </div>
      </div>
      <div className="mt-6 flex justify-center">
        <div
          className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full p-btn-grey text-white"
          onClick={onCloseModal}
        >
          Annuler
        </div>
        <div
          className="cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-green-400 text-white"
          onClick={onValidate}
        >
          Valider les forfaits repas
        </div>
      </div>
    </ModalComponent>
  );
};

export default ValidateMealPackagesModal;



// WEBPACK FOOTER //
// src/modules/presence/presence/modals/ValidateMealPackages.js